import React from 'react'
import { AphroditeIframe } from '@ui'
import { accessToken } from '@stores/apollo'
import { useFloor } from '@providers/mapProvider'
import { get } from 'lodash'

export default function EditFloorMap() {
  const floor = useFloor()

  const bname = get(floor, 'map.building.name', '')
  const fname = get(floor, 'map.name', '')
  const url = `/ap/Current/editmap/building/${bname}/floor/${fname}`

  return (
    <>
      <AphroditeIframe token={accessToken} path={url} />
    </>
  )
}
